const inits = {
  markers: [],
  allMarkers: [],
  markersExtent: null,
  filteredExtent: null,
  allFeatures: null
}

const MarkersReducer = (s = inits, action) => {
  const {payload} = action
  switch (action.type) {
    case '_MARKERS':
      return { ...s, [payload[0]]: payload[1] }
    case '_MARKERS_INIT':
      if(payload){
        return { ...s,
          markers: payload,
          allMarkers: payload
        }
      }else{
        return { ...s,
          markers: s.allMarkers
        }
      }

    default:
      return s;
  }
};
export default MarkersReducer
